const x = {
  filled: {
    pr: 3
  },
  ghost: {}
}, e = {
  md: {
    borderRadius: "xl",
    px: 3
  },
  lg: {
    borderRadius: "xxl",
    px: 4
  },
  xl: {
    borderRadius: "xxxl",
    px: 4
  },
  xxl: {
    borderRadius: "xxxl",
    px: 4
  }
}, p = {
  filled: {
    error: {
      "&": (r) => ({
        ...r.outline({ color: "error", radius: "xxxl" })
      })
    }
  }
}, l = {
  inputWrapper: x,
  inputWrapperSizes: e,
  inputWrapperVariantStateStyles: p
};
export {
  l as inputsTheme
};
